import * as React from 'react';
import { IconChevronRight } from '@americanexpress/dls-icons';
import { useModal } from '@/context/modalContext';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { NetworkHighlightBlock } from '../CulinaryCollective/interface';
import LFLink from '../common/LFLink';

interface NetworkHighlightsProps {
  highlights: NetworkHighlightBlock[];
}
const NetworkHighlights: React.FC<NetworkHighlightsProps> = ({
  highlights,
}) => {
  const { setModalName } = useModal();
  const { customTrack } = useAnalyticsContext();
  return (
    <div className="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-10 md_tw-grid-cols-3">
      {highlights?.map((highlightBlock) => {
        const { action } = highlightBlock;

        return (
          <div key={`network-highlight-block-${highlightBlock.title}`}>
            {highlightBlock.image && (
              <div className="tw-aspect-image tw-w-full tw-overflow-hidden tw-rounded-2xl">
                <img
                  src={highlightBlock.image}
                  alt={highlightBlock.title}
                  className="tw-h-full tw-w-full tw-object-cover"
                />
              </div>
            )}
            <div className="tw-mt-4 tw-font-sans tw-text-base tw-text-gray-800">
              <span className="tw-font-bold">{highlightBlock.title} — </span>
              <span
                dangerouslySetInnerHTML={{ __html: highlightBlock.description }}
              />
            </div>
            {!!action && (
              <div className="tw-mt-4">
                {action.type === 'dialog' ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      customTrack({
                        event: e,
                        element: 'The Centurion Network',
                        detail: 'Explore the Culinary Collective',
                      });
                      setModalName(action.dialogName);
                    }}
                    className="tw-font-medium tw-text-link hover_tw-underline"
                    type="button"
                  >
                    {action.text}
                    <IconChevronRight
                      size="xs"
                      isFilled={true}
                      className="tw-mb-px tw-ml-2 tw-mr-1 tw-text-blue-bright-shade-600-s8"
                    />
                  </button>
                ) : (
                  <LFLink
                    to={action.link}
                    className="tw-font-medium tw-text-link hover_tw-underline"
                  >
                    {action.text}
                    <IconChevronRight
                      size="xs"
                      isFilled={true}
                      className="tw-mb-px tw-ml-2 tw-mr-1 tw-text-blue-bright-shade-600-s8"
                    />
                  </LFLink>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NetworkHighlights;
